import { customElement, Disposable, BindingEngine, autoinject, bindingMode } from 'aurelia-framework';
import { MdcLookup } from '@aurelia-mdc-web/lookup';
import { bindable } from 'aurelia-typed-observable-plugin';
import { TransactionCategoriesCache } from '../../../services/transaction-categories-cache';
import { CategoryViewModel } from '@dynamik/common/clients/transaction-clients';
import { CustomerService } from '@dynamik/common';

@autoinject
@customElement('transaction-categories-lookup')
export class TransactionCategoriesLookup {
  constructor(private transactionCategoriesCache: TransactionCategoriesCache, private customerService: CustomerService, private bindingEngine: BindingEngine) { }

  clearFilter: any;

  @bindable.number({ defaultBindingMode: bindingMode.twoWay })
  value: number;

  @bindable.booleanAttr
  disabled: boolean;

  @bindable.booleanAttr
  readonly: boolean;

  @bindable
  placeholder: string;

  @bindable.number
  typeId: number;

  private filteredCategories: CategoryViewModel[];
  private allCategories: CategoryViewModel[];
  private categorysub: Disposable;
  private functionInput: any;
  private lookup: MdcLookup;

  async attached() {
    this.categorysub = this.bindingEngine.propertyObserverEx(this.customerService, 'transactionCategories')
      .subscribe(() => this.filteredCategories = undefined);
  }

  async detached() {
    this.categorysub.dispose();
  }

  async onFocus() {
    this.functionInput.value = '';
    await this.lookup.filterChanged();
  }

  getOptions = async (filter: string, value: number): Promise<CategoryViewModel[]> => {
    if (!this.filteredCategories) {
      this.allCategories = await this.transactionCategoriesCache.get();
      this.filteredCategories = this.allCategories.filter(c => c.securitiesCategoryType.id === this.typeId)
        .sort((a, b) => a.name.localeCompare(b.name));
    }
    if (value) {
      return Promise.resolve(this.filteredCategories.filter(cat => cat.id === value));
    } else {
      if (filter) {
        return Promise.resolve(this.filteredCategories.filter(x => x.name.toLowerCase().includes(filter.toLowerCase())));
      }
      return Promise.resolve([]);
    }
  };
}
